import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { RichText } from '../rich-text/rich-text.esm.js';

const Body = ({ children, className, left = false, right = false, center = false, ...rest })=>{
    const classes = classNames(className, 'p', {
        'text-end': right,
        'text-center': center,
        'text-start': left
    });
    return jsx(RichText, {
        as: "div",
        renderChildrenAsHTML: true,
        className: classes,
        ...rest,
        children: children
    });
};

export { Body };
